module.exports = __webpack_public_path__ + "static/media/logo-banese.f7c40f55.png";